import { Component, Input, OnInit } from '@angular/core';
import { CountryCallingInfo } from '../phone-numbers-dropdown/CountryCallingInfo';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-lg-country-code',
  templateUrl: './country-code.component.html',
  styleUrls: ['./country-code.component.scss']
})
export class CountryCodeComponent implements OnInit {
  @Input() public popupSettings: FormGroup;
  constructor() {}

  ngOnInit() {}

  changeSelectedNumber(event: CountryCallingInfo) {
    this.popupSettings.controls.forcedCountryCode.setValue(event.countryCode.toLowerCase());
  }
}
